import logo from './logo.svg';
import { useContext, useState } from "react";
import Section from "./components/section/section";
import Footer from "./components/footer/footer";
import { NextUIProvider, Container, Card, Grid, Link } from '@nextui-org/react';
import * as PIXI from 'pixi.js';
import { KawaseBlurFilter } from '@pixi/filter-kawase-blur';
import SimplexNoise from 'simplex-noise';
import hsl from 'hsl-to-hex';
import debounce from 'debounce';

import './App.css';
import CurrentWeather from './components/current-weather/current-weather';
import Forecast from './components/forecast/forecast';


function App() {
  const cardGlassStyles = {
    backdropFilter: "blur(3px) saturate(135%)",
    backgroundColor: "rgba(248, 248, 248, 0.39)",
    borderRadius: "12px",
    border: "1px solid rgba(209, 213, 219, 0.151)",
    boxShadow: "7px 22px 37px -9px rgba(58, 58, 58, 0.103)",
  };



  return (
      <NextUIProvider>
        <Container css={{mw: "960px", padding: "30px"}} fluid>
          <Card css={{backgroundColor: "transparent"}}>
            <Card.Body>
              <Grid.Container gap={2}>
                <Grid xs={12} md={12}lg={12}>
                  <Card css={cardGlassStyles}>
                    <Card.Body>
                      <CurrentWeather defaultCity="Barcelona"/>
                    </Card.Body>
                  </Card>
                </Grid>
              </Grid.Container>
            </Card.Body>
            <Card.Footer>
              <Footer />
            </Card.Footer>
          </Card>
        </Container>
      </NextUIProvider>
  );
}

export default App;
